import {
  cloneDeep,
  mergeWith
} from 'lodash-es';
import {
  action
} from './common';

export const types = {
  ENTITIES_ADD: 'ENTITIES/ADD',
  ENTITIES_RESET: 'ENTITIES/RESET',
};

export const actions = {
  addEntities: entities => action(types.ENTITIES_ADD, { entities }),
  resetEntities: () => action(types.ENTITIES_RESET),
};

const initialState = {
  appointments: {},
  customers: {},
  users: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ENTITIES_ADD:
      const {
        entities: {
          Appointment: appointments = {},
          Customer: customers = {},
          User: users = {},
        }
      } = action;

      return mergeWith(
        cloneDeep(state),
        {
          appointments,
          customers,
          users,
        }
      );

    case types.ENTITIES_RESET:
      return {
        ...initialState,
      };

    default:
     return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/entities.js